import React from "react";
import { FaCheck } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const SubscriptionPlansHome = () => {
    const navigate = useNavigate();

    // Prix mensuels
    const basicPrice = 0;
    const proPrice = 9.99;
    const businessPrice = 19.99;

    const getPrice = (price, billing) => {
        return billing === "yearly"
            ? (price * 12 * 0.9).toFixed(2) // -20% annuel
            : price.toFixed(2);
    };

    // toggle facturation
    const [billing, setBilling] = React.useState("monthly");

    return (
        <div className="lg:p-8 p-3 w-full flex flex-col justify-center" id="tarifs">
            <h2 className="font-bold font-Poppins text-blue-800 
                text-2xl sm:text-2xl md:text-2xl lg:text-4xl text-center   
                leading-snug lg:leading-[4rem] lg:mb-10 mb-5">
                Abonnements adaptés à vos besoins
            </h2>

            {/* Toggle facturation */}

            <div className="hidden lg:flex justify-center lg:mb-8 mb-4 gap-4">
                <button
                    className={`px-4 py-2 rounded-full border ${billing === "monthly"
                        ? "bg-blue-800 text-white"
                        : "bg-blue-200 text-blue-800"
                        }`}
                    onClick={() => setBilling("monthly")}
                >
                    Mensuelle
                </button>
                <button
                    className={`px-4 py-2 rounded-full border ${billing === "yearly"
                        ? "bg-blue-800 text-white"
                        : "bg-blue-200 text-blue-800"
                        }`}
                    onClick={() => setBilling("yearly")}
                >
                    Annuelle (-10%)
                </button>
            </div>
            <div className="   flex flex-col w-full gap-4 py-5
                        sm:grid sm:grid-cols-2 sm:justify-center
                        lg:flex lg:flex-row lg:justify-center lg:items-center
                    ">
                {/* Basic */}
                <div className="h-[550px] lg:w-[400px] w-full border-[1px] shadow-lg bg-color2 
          flex flex-col justify-between border-color5 rounded-xl gap-5 p-5">
                    <div className="flex flex-col items-center gap-2">
                        <p className="text-blue-800 text-4xl font-bold font-Poppins">
                            Basic
                        </p>
                        <p className="text-blue-700 lg:text-xl text-center text-lg font-semibold font-Poppins">
                            Faites un essai et testez vos super-pouvoirs
                        </p>
                        <p className="text-blue-600 lg:text-xl text-md font-semibold font-Poppins">
                            € / {billing === "monthly" ? "mois" : "an"}
                        </p>
                        <p className="text-blue-800 lg:text-5xl text-5xl font-semibold font-Poppins">
                            {basicPrice}
                        </p>
                    </div>

                    <div className="flex flex-col items-start gap-3 text-blue-600 justify-start w-full rounded-xl py-5 lg:px-5 px-1 bg-color22 ">
                        <div className="flex items-center gap-2">
                            <FaCheck className="text-color2 bg-color3 rounded-full p-1" size={21} />
                            <p >2 factures/devis par mois</p>
                        </div>
                        <div className="flex items-center gap-2">
                            <FaCheck className="text-color2 bg-color3 rounded-full p-1" size={21} />
                            <p>1 client max</p>
                        </div>
                        <div className="flex items-center gap-2">
                            <FaCheck className="text-color2 bg-color3 rounded-full p-1" size={21} />
                            <p>Relances manuelles seulement</p>
                        </div>
                        <div className="flex items-center gap-2">
                            <FaCheck className="text-color2 bg-color3 rounded-full p-1" size={21} />
                            <p>Support par email (réponse sous 48h)</p>
                        </div>
                    </div>

                    <p
                        onClick={() => navigate("/login")}
                        className="text-lg font-Poppins py-2 rounded-md text-center cursor-pointer bg-white text-color3 hover:bg-gray-100 transition"
                    >
                        S'inscrire gratuitement
                    </p>
                </div>



                {/* Toggle mobile (au-dessus du bloc Pro / Business) */}
                <div className="flex justify-center gap-4 my-2 lg:hidden">
                    <button
                        className={`px-4 py-2 rounded-full border ${billing === "monthly"
                            ? "bg-blue-800 text-white"
                            : "bg-blue-200 text-blue-800"
                            }`}
                        onClick={() => setBilling("monthly")}
                    >
                        Mensuelle
                    </button>
                    <button
                        className={`px-4 py-2 rounded-full border ${billing === "yearly"
                            ? "bg-blue-800 text-white"
                            : "bg-blue-200 text-blue-800"
                            }`}
                        onClick={() => setBilling("yearly")}
                    >
                        Annuelle (-10%)
                    </button>
                </div>

                {/* Pro */}
                <div className="relative h-[565px] lg:w-[400px] w-full border-[1px] shadow-lg bg-color20  flex flex-col justify-between border-color5 rounded-xl gap-5 p-5 lg:-mt-6">

                    {/* Badge Populaire */}
                    <div className="absolute top-3 left-3 bg-color15 text-white font-bold px-3 py-1 rounded-full text-sm shadow-md">
                        Populaire
                    </div>

                    {/* Badge -10% (seulement yearly) */}
                    {billing === "yearly" && (
                        <div className="absolute top-3 right-3 bg-red-600 text-white font-bold px-3 py-1 rounded-full text-sm shadow-md">
                            -10%
                        </div>
                    )}

                    <div className="flex flex-col items-center gap-2">
                        <p className="text-color2 text-4xl font-bold font-Poppins">
                            Pro
                        </p>
                        <p className="text-color2 lg:text-xl text-center text-lg font-semibold font-Poppins">
                            Expérimentez la puissance
                        </p>
                        <p className="text-color2 lg:text-xl text-md font-semibold font-Poppins">
                            € / {billing === "monthly" ? "mois" : "an"}
                        </p>
                        <p className="text-color2 text-5xl font-semibold font-Poppins">
                            {getPrice(proPrice, billing)}
                        </p>
                    </div>

                    <div className="flex flex-col items-start gap-3 justify-start text-blue-600 w-full rounded-xl py-5 lg:px-5 px-1 bg-color2">
                        <div className="flex items-center gap-2">
                            <FaCheck className="text-color2 bg-color3 rounded-full p-1" size={21} />
                            <p>Factures, devis et clients illimités</p>
                        </div>
                        <div className="flex items-center gap-2">
                            <FaCheck className="text-color2 bg-color3 rounded-full p-1" size={21} />
                            <p>Relances manuelle et automatique</p>
                        </div>
                        <div className="flex items-center gap-2">
                            <FaCheck className="text-color2 bg-color3 rounded-full p-1" size={21} />
                            <p>Exporter données Exel/CSV</p>
                        </div>
                        <div className="flex items-center gap-2">
                            <FaCheck className="text-color2 bg-color3 rounded-full p-1" size={21} />
                            <p>Personnalisation PDF</p>
                        </div>
                        <div className="flex items-center gap-2">
                            <FaCheck className="text-color2 bg-color3 rounded-full p-1" size={21} />
                            <p>Support par email (réponse sous 24h)</p>
                        </div>
                    </div>

                    <p
                        onClick={() => navigate("/login")}
                        className="text-lg font-Poppins py-2 rounded-md text-center cursor-pointer bg-color3 text-color2 hover:bg-color3/90 transition"
                    >
                        Passer à Pro
                    </p>
                </div>


                {/* Toggle mobile (au-dessus du bloc Pro / Business) */}
                <div className="flex justify-center gap-4 my-4 lg:hidden">
                    <button
                        className={`px-4 py-2 rounded-full border ${billing === "monthly"
                            ? "bg-blue-800 text-white"
                            : "bg-blue-200 text-blue-800"
                            }`}
                        onClick={() => setBilling("monthly")}
                    >
                        Mensuelle
                    </button>
                    <button
                        className={`px-4 py-2 rounded-full border ${billing === "yearly"
                            ? "bg-blue-800 text-white"
                            : "bg-blue-200 text-blue-800"
                            }`}
                        onClick={() => setBilling("yearly")}
                    >
                        Annuelle (-10%)
                    </button>
                </div>

                {/* Business */}
                <div className="relative h-[550px] lg:w-[400px] w-full border-[1px] shadow-lg bg-color2 flex flex-col justify-between border-color5 rounded-xl gap-5 p-5">

                    {/* Badge -10% (seulement yearly) */}
                    {billing === "yearly" && (
                        <div className="absolute top-3 right-3 bg-red-600 text-white font-bold px-3 py-1 rounded-full text-sm shadow-md">
                            -10%
                        </div>
                    )}

                    <div className="flex flex-col items-center gap-2">
                        <p className="text-blue-800 text-4xl font-bold font-Poppins">
                            Business
                        </p>
                        <p className="text-blue-700 lg:text-xl text-center text-lg font-semibold font-Poppins">
                            Prenez le contrôle de votre business, concentrez-vous sur l’essentiel
                        </p>
                        <p className="text-blue-600 lg:text-xl text-md font-semibold font-Poppins">
                            € / {billing === "monthly" ? "mois" : "an"}
                        </p>
                        <p className="text-blue-800 text-5xl font-semibold font-Poppins">
                            {getPrice(businessPrice, billing)}
                        </p>
                    </div>

                    <div className="flex flex-col items-start text-blue-600 gap-3 justify-start w-full rounded-xl py-5 lg:px-5 px-1 bg-color22">
                        <div className="flex items-center gap-2">
                            <FaCheck className="text-color2 bg-color3 rounded-full p-1" size={21} />
                            <p>Tout le plan Pro</p>
                        </div>
                        <div className="flex items-center gap-2">
                            <FaCheck className="text-color2 bg-color3 rounded-full p-1" size={21} />
                            <p>Invitez votre comptable</p>
                        </div>
                        <div className="flex items-center gap-2">
                            <FaCheck className="text-color2 bg-color3 rounded-full p-1" size={21} />
                            <p>Intégration chat en direct</p>
                        </div>
                    </div>

                    <p
                        onClick={() => navigate("/login")}
                        className="text-lg font-Poppins py-2 rounded-md text-center cursor-pointer bg-white text-color3 hover:bg-gray-100 transition"
                    >
                        Passer à Business
                    </p>

                </div>

            </div>
        </div>
    );
};

export default SubscriptionPlansHome;
